import { Component, Input, OnChanges } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Observable } from 'rxjs/Observable'

import { Form } from '../../../forms/models'
import { BaseModel } from '../../../data/models'
import { AppInjector, FormHelper } from '../../../helpers'
import { FormMapper, PromptControlService } from '../../../forms/services'
import { ModelRepositoryAdapter } from '../../../model-repository'

@Component({
  selector: 'mp-dynamic-form',
  templateUrl: './dynamic-form.html'
})
export class DynamicFormComponent implements OnChanges {

  @Input() public modelObservable: Observable<BaseModel>
  @Input() public previewMode: boolean = false

  public formModel: Form<BaseModel>
  public formGroup: FormGroup

  private _service: ModelRepositoryAdapter<BaseModel>

  constructor(
    private _formMapper: FormMapper,
    private _promptControlService: PromptControlService,
    private _formHelper: FormHelper,
    private _appInjector: AppInjector
  ) {  }

  public ngOnChanges(changes) {
    if (this._modelObservableChanged(changes)) {
      this.modelObservable.subscribe((model) => {
        this._service = this._appInjector.getServiceForModel<ModelRepositoryAdapter<BaseModel>>(model.type)
        this.formModel = this._formMapper.toForm(model)
        this.formGroup = this._promptControlService.toFormGroup(this.formModel.prompts)
        if (this.previewMode) {
          this.formGroup.disable()
        }
      })
    }
  }

  public onSubmit() {
    this._formMapper.toModel(this.formModel.model, this.formGroup.value).subscribe((mappedModel) => {
      const messages = {
        success: 'Entry successfully saved!',
        error: 'Saving entry failed!'
      }

      this._formHelper.formProcessingMessenger(
        this.formGroup, this._service.save(mappedModel), messages
      ).subscribe()
    })
  }

  private _modelObservableChanged(changes) {
    const previous = changes.modelObservable.previousValue
    const current = changes.modelObservable.currentValue
    return !previous || current.value != previous.value
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/dynamic-form/dynamic-form.component.ts